import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE } from '../../../constants/general.constants';
import { ProjectWasmModule } from '../../../interfaces/wasm-module.interface';

/**
 * API service for WASM module CRUD operations against nc-server.
 *
 * This is separate from WasmModuleService which handles runtime
 * loading and execution of modules in the browser.
 */
@Injectable({
  providedIn: 'root',
})
export class WasmModuleApiService {
  private readonly http = inject(HttpClient);

  private moduleUrl(projectId: number, moduleId?: number): string {
    let url = `${API_BASE}/project/${projectId}/wasm-module`;
    if (moduleId !== undefined) {
      url += `/${moduleId}`;
    }
    return url;
  }

  /**
   * List all WASM modules for the current version of a project.
   */
  listModules(projectId: number): Observable<ProjectWasmModule[]> {
    return this.http.get<ProjectWasmModule[]>(this.moduleUrl(projectId));
  }

  /**
   * Get a single WASM module by ID.
   */
  getModule(projectId: number, moduleId: number): Observable<ProjectWasmModule> {
    return this.http.get<ProjectWasmModule>(this.moduleUrl(projectId, moduleId));
  }

  /**
   * Delete a WASM module and its S3 bundle.
   */
  deleteModule(projectId: number, moduleId: number): Observable<void> {
    return this.http.delete<void>(this.moduleUrl(projectId, moduleId));
  }
}
